import React from 'react';


export default function NotFoundPage() {
  return (
    <div className="container">
      <div className="flex justify-center items-center" style={{ height: "100vh" }}>
        <div style={{ textAlign: "center" }}>
          {/* <img src={NotFoundImage} alt="404 Not Found" style={{ maxWidth: "100%", height: "auto" }} /> */}
          <div style={{ paddingTop: "20px", fontSize: "24px" }}>The page you’re looking for could not be found</div>
          <div style={{ paddingTop: "20px", fontSize: "18px", color: "grey" }}>Please make sure the web address is correct.</div>
        </div>
      </div>
    </div>
  );
}
